import { guardNumber } from "../numbers";
import { Constants } from "./constants";
import { getArticleGroupNumberString } from "./get-article-group-number-string";

export function getArticleProductTypeNumberString(
	articleGroupNumber: number,
	articleProductTypeNumber: number,
) {
	const articleGroupNumberString = getArticleGroupNumberString(articleGroupNumber);
	const number = guardNumber(articleProductTypeNumber);
	const articleProductTypeNumberString =
		`${Constants.ARTICLE_PRODUCT_TYPE_NUMBER_PREFIX}${number.toString().padStart(Constants.ARTICLE_PRODUCT_TYPE_NUMBER_PADDING, "0")}`.trim();
	return [articleGroupNumberString, articleProductTypeNumberString].join(Constants.NUMBER_JOINER);
}
